module.exports = __webpack_public_path__ + "static/media/bell-icon.19596fee.svg";